(function () {
  // Prefer Shopify's active locale, then fall back to the document language.
  const shopifyLocale = window.Shopify && typeof window.Shopify.locale === 'string'
    ? window.Shopify.locale
    : '';
  const documentLocale = document.documentElement && typeof document.documentElement.lang === 'string'
    ? document.documentElement.lang
    : '';
  const locale = (shopifyLocale || documentLocale || 'en').toLowerCase().split('-')[0];

  if (locale === 'en') return;

  // Kiwi renders chart copy outside Shopify Translate & Adapt, so keep the
  // chart-specific dictionary here instead of relying on theme locale strings.
  const translations = {
    hr: {
      'SIZE': 'VELIČINA',
      'ADIDAS MEN': 'ADIDAS MUŠKARCI',
      'ADIDAS WOMAN': 'ADIDAS ŽENE',
      'ADIDAS WOMEN': 'ADIDAS ŽENE',
      'ADIDAS KIDS': 'ADIDAS DJECA',
      'ADIDAS SOCKS': 'ADIDAS ČARAPE',
      'ADIDAS INTERNATIONAL CONVERSION': 'ADIDAS MEĐUNARODNA KONVERZIJA',
      'HEIGHT/BODY (CM)': 'VISINA TIJELA (CM)',
      'HEIGHT (CM)': 'VISINA (CM)',
      'CHEST (CM)': 'PRSA (CM)',
      'WAIST (CM)': 'STRUK (CM)',
      'HIP (CM)': 'BOKOVI (CM)',
      'INNER LEG (CM)': 'UNUTRAŠNJA NOGA (CM)'
    },
    it: {
      'SIZE': 'TAGLIA',
      'ADIDAS MEN': 'ADIDAS UOMO',
      'ADIDAS WOMAN': 'ADIDAS DONNA',
      'ADIDAS WOMEN': 'ADIDAS DONNA',
      'ADIDAS KIDS': 'ADIDAS BAMBINI',
      'ADIDAS SOCKS': 'ADIDAS CALZE',
      'ADIDAS INTERNATIONAL CONVERSION': 'CONVERSIONE INTERNAZIONALE ADIDAS',
      'HEIGHT/BODY (CM)': 'ALTEZZA CORPO (CM)',
      'HEIGHT (CM)': 'ALTEZZA (CM)',
      'CHEST (CM)': 'PETTO (CM)',
      'WAIST (CM)': 'VITA (CM)',
      'HIP (CM)': 'FIANCHI (CM)',
      'INNER LEG (CM)': 'INTERNO GAMBA (CM)'
    },
    de: {
      'SIZE': 'GRÖSSE',
      'ADIDAS MEN': 'ADIDAS HERREN',
      'ADIDAS WOMAN': 'ADIDAS DAMEN',
      'ADIDAS WOMEN': 'ADIDAS DAMEN',
      'ADIDAS KIDS': 'ADIDAS KINDER',
      'ADIDAS SOCKS': 'ADIDAS SOCKEN',
      'ADIDAS INTERNATIONAL CONVERSION': 'INTERNATIONALE ADIDAS-UMRECHNUNG',
      'HEIGHT/BODY (CM)': 'KÖRPERGRÖSSE (CM)',
      'HEIGHT (CM)': 'GRÖSSE (CM)',
      'CHEST (CM)': 'BRUST (CM)',
      'WAIST (CM)': 'TAILLE (CM)',
      'HIP (CM)': 'HÜFTE (CM)',
      'INNER LEG (CM)': 'INNENBEINLÄNGE (CM)'
    }
  };

  const dictionary = translations[locale];
  if (!dictionary) return;

  // Scope all DOM work to Kiwi chart containers to avoid changing product copy,
  // page headings, or other translated storefront content.
  const kiwiContainerSelector = [
    '.kiwi-sizing-modal',
    '.ks-chart-modal',
    '.ks-chart-tab-container',
    '.ks-chart-individual',
    '.ks-table-wrapper',
    '.ks-table',
    '#KiwiSizingChart',
    '[class*="kiwi"][class*="sizing"]',
    '[class*="ks-chart"]'
  ].join(',');

  // Target only chart headings and table headers; size values such as S, M, L
  // and measurements should remain exactly as Kiwi provides them.
  const translatableTextSelector = [
    'th',
    '.ks-table-header-cell',
    '.ks-table-row:first-child .ks-table-cell',
    '.ks-table-row:first-child td',
    '.ks-table-row:first-child div',
    '.ks-chart-modal-button',
    '.ks-chart-modal-button ._ks_text',
    '.modal-title',
    '.modal-title-header',
    '.modal-title-sub-header',
    '[class*="header"]',
    '.ks-html-content span'
  ].join(',');

  function getKiwiContainers(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return [];

    const containers = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(kiwiContainerSelector)) {
      containers.push(root);
    }

    root.querySelectorAll(kiwiContainerSelector).forEach((container) => {
      containers.push(container);
    });

    return containers;
  }

  function translateElement(element) {
    if (!element) return;

    // Normalize whitespace and compare uppercase values so Kiwi markup changes
    // do not break simple text matches.
    const originalText = element.textContent.trim().replace(/\s+/g, ' ');
    const translatedText = dictionary[originalText.toUpperCase()];
    const shouldExposeOriginal = element.matches(
      '.ks-chart-modal-button, .ks-chart-modal-button *, .modal-title, .modal-title-header, .modal-title-sub-header'
    );

    if (!translatedText && !shouldExposeOriginal) return;

    const sourceText = translatedText || originalText;
    if (translatedText) element.textContent = element.textContent.replace(originalText, translatedText);
    element.setAttribute('data-weglot-dynamic', 'text');
    element.setAttribute('data-weglot-source', sourceText);
    element.dataset.kiwiLocalized = 'true';
  }

  function translateContainer(container) {
    container.querySelectorAll(translatableTextSelector).forEach(translateElement);
    notifyDynamicContent(container);
  }

  function translateKiwiSizeCharts(root = document) {
    getKiwiContainers(root).forEach(translateContainer);
  }

  function notifyDynamicContent(root) {
    if (!root) return;

    root.dispatchEvent(new CustomEvent('fk:dynamic-content:rendered', { bubbles: true, detail: { root } }));

    if (window.fkWeglotDynamic && typeof window.fkWeglotDynamic.refresh === 'function') {
      window.fkWeglotDynamic.refresh(root);
    }
  }

  // Translate immediately when possible, or wait for the initial DOM if this
  // asset loads before the product section has finished rendering.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => translateKiwiSizeCharts(), { once: true });
  } else {
    translateKiwiSizeCharts();
  }

  if (!document.body) return;

  // Kiwi renders and re-renders its modal/table after page load, so observe
  // product-section updates and modal insertions without touching non-Kiwi DOM.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => translateKiwiSizeCharts(node));

      if (
        mutation.type === 'characterData' &&
        mutation.target.parentElement &&
        mutation.target.parentElement.closest(kiwiContainerSelector)
      ) {
        translateKiwiSizeCharts(mutation.target.parentElement.closest(kiwiContainerSelector));
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
